module.exports = __webpack_public_path__ + "img/xjb1.460c66e8.jpg";